import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

// Legacy redirect — `/organizations/<code>` was merged into the drawer on the
// list page. Replace with `/organizations?org=<code>` so deep links keep
// landing on the correct organization.
export const Route = createFileRoute('/organizations/$orgCode')({
  component: RedirectComponent,
})

function RedirectComponent() {
  const { orgCode } = Route.useParams()
  const navigate = useNavigate()

  useEffect(() => {
    navigate({ to: '/organizations', search: { org: orgCode } as any, replace: true })
  }, [navigate, orgCode])

  return null
}
